module.exports = require('./assignIn');



//////////////////
// WEBPACK FOOTER
// ../node_modules/velocity-react/node_modules/lodash/extend.js
// module id = 1044
// module chunks = 0